import { AnimatePresence, motion } from 'framer-motion';

type RevealerProps = {
  revealed: boolean;
  children: React.ReactNode;
  duration?: number;
};

export const Reveal = ({ revealed = false, children, duration = 0.4 }: RevealerProps) => {
  return (
    <AnimatePresence mode="wait">
      {revealed && (
        <motion.div
          initial={{
            transformOrigin: 'top',
            scaleY: 0.62,
            height: 0,
            opacity: 0,
          }}
          animate={{
            scaleY: 1,
            height: 'auto',
            opacity: 1,
            transition: {
              height: {
                duration,
              },
              opacity: {
                duration: duration / 2,
                delay: 0.1,
              },
            },
          }}
          exit={{
            scaleY: 0.62,
            height: 0,
            opacity: 0,
            transition: {
              height: {
                duration,
              },
              opacity: {
                duration: duration / 2,
              },
            },
          }}
          key="reveal-key"
          className="font-light"
        >
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  );
};
